__turbopack_context__.v({
  "accordion-card": "AcfAccordionItem-module-scss-module__47IA_G__accordion-card",
  "accordion-heading": "AcfAccordionItem-module-scss-module__47IA_G__accordion-heading",
  "accordion-rich-text": "AcfAccordionItem-module-scss-module__47IA_G__accordion-rich-text",
});
